export default "__VITE_ASSET__BYIM$8xX__"